var _defs, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 48,
    viewBox: "0 0 111 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_994_94",
    x1: 0,
    y1: 0,
    x2: 77.8461,
    y2: 9.73773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.183111,
    stopColor: "#FF56F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432593,
    stopColor: "#B936EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854443,
    stopColor: "#3BACE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#406AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_994_94",
    x1: 0,
    y1: 0,
    x2: 77.8461,
    y2: 9.73773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.183111,
    stopColor: "#FF56F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432593,
    stopColor: "#B936EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854443,
    stopColor: "#3BACE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#406AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_994_94",
    x1: 0,
    y1: 0,
    x2: 77.8461,
    y2: 9.73773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.183111,
    stopColor: "#FF56F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432593,
    stopColor: "#B936EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854443,
    stopColor: "#3BACE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#406AFF"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 10,
    y: 30,
    fontFamily: "Arial, sans-serif",
    fontSize: 33,
    fill: "url(#paint0_linear_994_94)"
  }, "Kevin Dev ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8b8e2692e84ab4478551f6ac778e168f.svg";
export { ForwardRef as ReactComponent };